<template>
    <div>
        <div class="flex between">
            <el-form :model="po" ref="poRef" label-width="80px" inline>
                <el-form-item prop="type" label="类型">
                    <el-select v-model="po.type" clearable>
                        <el-option :key="item.value" :label="item.name" :value="item.value" v-for="item in po.types" />
                    </el-select>
                </el-form-item>
                <!-- <el-form-item prop="timeRange" label="有效期">
                    <el-date-picker
                        v-model="po.timeRange"
                        type="daterange"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        value-format="YYYY-MM-DD"
                    />
                </el-form-item> -->
                <el-form-item label-width="15px">
                    <el-button @click="resetHandler">重置</el-button>
                    <el-button type="primary" @click="searchHandler">查询</el-button>
                </el-form-item>
            </el-form>
            <div class="table-opt">
                <el-button @click="addHandler">新增</el-button>
            </div>
        </div>
        <!-- 表格 -->
        <el-table :data="vo.tableList" style="width: 100%" v-loading="vo.loading">
            <el-table-column label="类型">
                <template #default="{ row }"> {{ row.type === 0 ? '优惠券' : '代金券' }} </template>
            </el-table-column>
            <el-table-column label="供应商">
                <template #default="{ row }"> {{ couponSupply(row.sid) }} </template>
            </el-table-column>
            <el-table-column prop="no" label="批次号"> </el-table-column>
            <el-table-column prop="money" label="面额"> </el-table-column>
            <el-table-column prop="num" label="数量"> </el-table-column>
            <el-table-column label="有效期">
                <template #default="{ row }"> {{ row.startDate }} - {{ row.endDate }} </template>
            </el-table-column>
            <el-table-column prop="created" label="创建时间"> </el-table-column>
            <el-table-column label="操作" min-width="120" class-name="deal-column">
                <template #default="{ row }">
                    <el-button text type="primary" @click="detailClick(row)"> 查看详情 </el-button>
                    <el-button text type="primary" @click="deleteClick(row)"> 删除 </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-style">
            <el-pagination
                background
                layout="prev, pager, sizes, next"
                :total="vo.total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            />
        </div>
        <FormDialog
            :visible="dialogVisible"
            @parentCallback="parentCallback"
            @closeDialog="handleCloseDialog"
            :articleId="po.targetArticleId"
            v-if="dialogVisible"
        />
        <DetailDialog
            :visible="po.detailVisible"
            @closeDialog="closeDialog"
            :couponObj="po.targetCoupon"
            v-if="po.detailVisible"
        />
    </div>
</template>
<script setup>
import { ElMessage, ElMessageBox } from 'element-plus';
import request from '@/request/index';
import { reactive, ref } from 'vue';
import FormDialog from './form.vue';
import DetailDialog from './detail.vue';
const po = reactive({
    types: [
        {
            value: 0,
            name: '优惠券'
        },
        {
            value: 1,
            name: '代金券'
        }
    ],
    timeRange: [],
    type: '',
    cid: '',
    supplies: [],
    detailVisible: false,
    targetCoupon: null,
    pageObj: {
        perPage: 10,
        page: 1
    }
});
const vo = reactive({ tableList: [], loading: true, total: 0 });
const dialogVisible = ref(false);

const couponSupply = sid => {
    const tempSupply = po.supplies.find(item => item.id === sid);
    return tempSupply ? tempSupply.company_name : '-';
};

// 根据应用查询角色级联信息
const queryInitHandler = async function () {
    vo.loading = true;
    let filterParams = { type: po.type, ...po.pageObj };
    if (po.timeRange && po.timeRange.length > 0) {
        filterParams.startDate = po.timeRange[0];
        filterParams.endDate = po.timeRange[1];
    }
    const result = await request('serialLists', filterParams);
    const list = result.data.list;
    if (result.data.totalCount === 0) {
        vo.tableList = [];
    } else {
        vo.tableList = list;
    }
    vo.total = result.data.totalCount;
    vo.loading = false;
};
queryInitHandler();

const handleSizeChange = function (e) {
    po.pageObj.perPage = e;
    po.pageObj.page = 1;
    queryInitHandler();
};
const handleCurrentChange = function (e) {
    po.pageObj.page = e;
    queryInitHandler();
};
const poRef = ref(null);
const resetHandler = function () {
    poRef.value.resetFields();
    queryInitHandler();
};
const searchHandler = function () {
    po.pageObj.page = 1;
    queryInitHandler();
};
const openDialog = () => {
    dialogVisible.value = true;
};
const addHandler = () => {
    po.targetArticleId = 0;
    openDialog();
};
const closeDialog = () => {
    po.detailVisible = false;
};
const handleCloseDialog = () => {
    dialogVisible.value = false;
};
const deleteClick = row => {
    ElMessageBox.confirm('确认要删除此配置吗', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
    })
        .then(async () => {
            const result = await request('serialDelete', {
                no: row.no
            });
            if (result.status === 200) {
                ElMessage({
                    message: result.msg,
                    type: 'success'
                });
                queryInitHandler();
            }
        })
        .catch(() => {
            console.log('cancel');
        });
};
const detailClick = e => {
    po.targetCoupon = e;
    po.detailVisible = true;
};
const editClick = article => {
    po.targetArticleId = article.id;
    openDialog();
};
const parentCallback = function () {
    handleCloseDialog();
    queryInitHandler();
};
const querySupplyHandler = async function () {
    const result = await request('queryUserLists', { level: 3 });
    const list = result.data.list;
    po.supplies = list;
};
querySupplyHandler();
</script>
